import styled from 'styled-components';

import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';
import IconComponent from 'shared/components/presentational/Icons';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import Picture from 'shared/components/presentational/Picture';
import Raw from 'shared/components/presentational/Raw/Raw';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
  width: 100%;
`;

export const Item = styled.button`
  display: flex;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
  font-size: var(--text-size-base);
  font-weight: ${FONT_WEIGHTS.demi};
  color: var(--text-title);

  &:focus-visible {
    outline: auto;
  }
`;

export const Title = styled.h3`
  font-size: var(--text-size-base);
  font-weight: ${FONT_WEIGHTS.demi};
  font-family: ${FONT_FAMILIES.base};
  color: var(--text-title);
  margin: 0;
`;

export const Icon = styled(IconComponent)`
  color: var(--icons-default);
`;

export const Description = styled.div`
  display: flex;
  gap: var(--spacing-xs);

  picture {
    width: 16px;
  }
`;

export const Channel = styled(Picture)`
  display: flex;
  height: 39px;
  width: 52px;
  display: block;
  margin: auto;
  object-fit: contain;

  ${mediaQueries.fromTablet`
    height: 48px;
    width: 64px;
  `}

  ${mediaQueries.fromDesktop`
    height: 66px;
    width: 88px;
  `}
`;

export const ChannelWrapper = styled.div`
  display: grid;
  gap: var(--spacing-xs);
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(5, 1fr);
  position: relative;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
  font-size: var(--text-size-s);
  color: var(--text-light);

  &[aria-hidden='true'] {
    display: none;
  }
`;

export const StyledRaw = styled(Raw)<{ hasMarginLeft: boolean }>`
  margin-left: ${({ hasMarginLeft }) =>
    hasMarginLeft ? 'var(--spacing-xl)' : '0'};
`;
